module.exports = __webpack_public_path__ + "static/media/banner.lg.56909619.png";